import { defineComponent as n, openBlock as r, createBlock as l, unref as a, mergeProps as c, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconBellFilled",
  __name: "IconBellFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (r(), l(a(i), c(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", { d: "M12 2.125c-1.774 0-3.485.657-4.755 1.842C5.937 5.188 5.25 7.23 5.25 8.875v3.5c0 1.836-.893 2.485-1.268 2.69C3.61 15.27 3.25 15.69 3.25 16.253v.123a1.25 1.25 0 0 0 1.25 1.25h15a1.25 1.25 0 0 0 1.25-1.25V16.24c0-.547-.343-.963-.708-1.17-.388-.22-1.292-.899-1.292-2.694v-3.5c0-1.646-.687-3.687-1.995-4.908-1.27-1.184-2.982-1.842-4.755-1.842m-1.928 16.499a.8.8 0 0 0-.79.92 2.75 2.75 0 0 0 5.436 0 .8.8 0 0 0-.79-.92h-3.856" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
